/**
 * withTimeout(promise, ms, message)
 *
 * Races a promise against a timeout so a hung network/Firestore/AI call can
 * never block the UI (or an in-flight save-lock) forever. If `promise` doesn't
 * settle within `ms`, the returned promise REJECTS with an Error carrying
 * `message` (and `.code = 'timeout'` so friendlyError maps it to a connection
 * message). The underlying promise is left to settle on its own — we don't
 * cancel it, we just stop waiting.
 */
export function withTimeout(promise, ms = 30000, message = 'This is taking too long - please check your connection and try again.') {
  let timer;
  const timeout = new Promise((_resolve, reject) => {
    timer = setTimeout(() => {
      const err = new Error(message);
      err.code = 'timeout';
      reject(err);
    }, ms);
  });
  return Promise.race([promise, timeout]).finally(() => clearTimeout(timer));
}

export default withTimeout;
